import classes from "./confirmationModal.module.css";
import { CloseIcon } from "../../constants/svg";
import { useState } from "react";

const ConfirmationModal = ({ title, message, onConfirm, onCancel, toast }) => {
  const [showModal, setShowModal] = useState(true);

  const handleConfirm = () => {
    setShowModal(false);
    if (toast) toast.dismiss();
    onConfirm();
  };

  const handleCancel = () => {
    setShowModal(false);
    if (toast) toast.dismiss();
    onCancel();
  };

  return (
    <div className={classes.bg}>
      <div className={`${classes.parent} ${classes.jpsParent}`}>
        <span
          className="center-flex"
          onClick={handleCancel}
        >
          <CloseIcon color={"#030659"} />
        </span>
        <div className="relative">
          <p className={classes.title}>{title}</p>
          {message && <p className={classes.message}>{message}</p>}
          
          <div className={classes.buttonContainer}>
            <button 
              className={`${classes.button} ${classes.cancelButton}`}
              onClick={handleCancel}
            >
              No
            </button>
            <button 
              className={`${classes.button} ${classes.confirmButton}`}
              onClick={handleConfirm}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;